/**
 * © [2020] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */

import * as actionTypes from './actionTypes';
import * as serviceEndPoint from '../../../../SharedModules/services/service';
import axios from 'axios';

export const dispatchPlanTypeFilterData = (data) => ({
  type: actionTypes.GET_PLAN_TYPE_DATA,
  checkbox: data,
});

export const dispatchQuarterForAPI = (data) => ({
  type: actionTypes.QTR_VALUE_FOR_API,
  quarterInAPI: data,
});

export const getCheckBoxValue = () => (dispatch) => {
  return axios
    .post(serviceEndPoint.GET_COMMON_MANUFACUTRE_DROPDOWNS, {
      codeDomainList: ['PLAN_TYPE_CD'],
    })
    .then((response) => {
      return dispatch(dispatchPlanTypeFilterData(response.data));
    })
    .catch((response) => {
      dispatch(dispatchPlanTypeFilterData([]));
    });
};

export const dispatchCommonDropdownData = (data) => ({
  type: actionTypes.GET_COMMON_DROPDOWN_DATA,
  dropdown: data,
});

export const getCommonDropdownList = (value) => {
  return axios
    .post(serviceEndPoint.SYSTEM_LIST_ALL_DROPDOWN, { planType: value })
    .then((response) => {
      return response.data;
    })
    .catch((response) => {
      return [];
    });
};

export const dispatchQuarterData = (data) => ({
  type: actionTypes.GET_QUARTER_DATA,
  quarter: data,
});

export const getQuarterData = (value) => (dispatch) => {
  return axios
    .post(serviceEndPoint.GET_QUARTER_DATA)
    .then((response) => {
      return dispatch(dispatchQuarterData(response.data));
    })
    .catch((response) => {
      dispatch(dispatchQuarterData([]));
    });
};

export const dispatchManufacturerData = (data) => ({
  type: actionTypes.GET_MANUFACTURER_DATA,
  manufacturer: data,
});

export const getManufacturerData = (value) => (dispatch) => {
  return axios
    .post(serviceEndPoint.GET_MANUFACTURER_DETAILS_DATA, value)
    .then((response) => {
      return dispatch(dispatchManufacturerData(response.data));
    })
    .catch((response) => {
      dispatch(dispatchManufacturerData([]));
    });
};

export const dispatchCheckDetailsData = (data) => ({
  type: actionTypes.GET_CHECK_DETAILS,
  checkDetails: data,
});

export const getCheckDetailsData = (value) => (dispatch) => {
  return axios
    .post(serviceEndPoint.GET_CHECK_DETAILS_DATA, value)
    .then((response) => {
      return dispatch(dispatchCheckDetailsData(response.data));
    })
    .catch((response) => {
      dispatch(dispatchCheckDetailsData([]));
    });
};

export const dispatchErrorMessageData = (data) => ({
  type: actionTypes.HANDLE_ERROR_MSG_CBI,
  errorMessageInRedux: data,
});

export const setSelectedRebateProgram = (val) => {
  return {
    type: actionTypes.SELECTED_REBATE_PROGRAM,
    selectedRebateProgram: val,
  };
};

export const disQuarter = (val) => {
  return {
    type: actionTypes.QTR_VALUE,
    quarterInput: val,
  };
};

export const disSearchDisabled = (val) => {
  return {
    type: actionTypes.SEARCH_DISABLED,
    searchStatus: val,
  };
};

export const disRowSelected = (val) => {
  return {
    type: actionTypes.ROW_SELECTED,
    rowSelected: val,
  };
};

export const clearRedux = (payload) => {
  return {
    type: actionTypes.CLEAR_REDUX,
  };
};
export const clearReduxForChecksByInvoices = () => (dispatch) => {
  dispatch(dispatchQuarterForAPI(''));
  dispatch(dispatchQuarterData(''));
  dispatch(dispatchPlanTypeFilterData([]));
  dispatch(dispatchManufacturerData([]));
  dispatch(dispatchCheckDetailsData([]));
  dispatch(dispatchErrorMessageData([]));
  dispatch(setSelectedRebateProgram({}));
  dispatch(disQuarter(''));
  dispatch(disSearchDisabled(''));
  dispatch(disRowSelected({}));
};
